import _ from "lodash";

const IGNORED_NETWORK_ERRORS = ["ERR_NETWORK", "ERR_CANCELED", "ECONNABORTED"];
const IGNORED_FETCH_ERROR_MESSAGES = ["Network request failed"];

export function sentryBeforeSend(event, hint) {
  const networkError = _.get(hint, "originalException.code");
  const exceptionMessage = _.get(hint, "originalException.message") || _.get(hint, "originalException.value");
  const isFetchNetworkError =
    _.get(hint, "originalException.name") === "TypeError" && IGNORED_FETCH_ERROR_MESSAGES.includes(exceptionMessage);
  if (
    IGNORED_NETWORK_ERRORS.includes(networkError) ||
    isFetchNetworkError ||
    _.get(hint, "originalException.status") == "401" ||
    (_.get(hint, "originalException.status") == "403" &&
      _.get(hint, "originalException.response.data.errorCode") === 1001)
  ) {
    return null;
  }

  const exceptions = _.get(event, "exception.values", []);
  const isFabricSchedulerCrash = _.some(
    exceptions,
    (ex) =>
      _.get(ex, "type") === "EXC_BAD_ACCESS" &&
      _.some(
        _.get(ex, "stacktrace.frames", []),
        (frame) =>
          frame && frame.filename === "Scheduler.cpp" && _.includes(frame.function, "uiManagerDidFinishTransaction"),
      ),
  );
  if (isFabricSchedulerCrash) {
    return null;
  }

  return event;
}
